const taskAddRows = [
  {
    columns: [
      {
        default: 12,
        xs: 12,
        field: {
          id: "description",
          title: "Description",
          type: "text-area",
          required: true,
        },
      },
    ],
  },
  {
    columns: [
      {
        default: 12,
        xs: 12,
        field: {
          id: "dueDate",
          title: "Due Date",
          type: "text",
          variant: "date",
          required: true,
        },
      },
    ],
  },
];

export const formJson = {
  forms: [
    {
      name: "New Task",
      markCompulsoryFields: true,
      hideFormName: true,
      preFix: "task",
      submit: {
        name: "Submit",
        show: true,
        onSubmit: "onTaskAddSubmit",
      },
      rows: taskAddRows,
    },
  ],
};
